export default __webpack_public_path__ + "static/gptw-4a035addc06dce9242a5a3cc731a2df4.png";